import {
  Breakpoints,
  DesignTokenSizeEnum,
  Gallery,
  GalleryContext,
  GallerySlide,
} from '@volkswagen-onehub/components-core';
import useResizeResponsive from '@/hooks/useResizeResponsive';
import { isMobile } from '@/modules/utils/breakpoints';
import VehicleToggleButton, {
  BackgroundVals,
  VehicleToggleButtonProps,
} from '../VehicleToggleButton/VehicleToggleButton';
import { VehicleToggleButtonCarouselWrapper } from './VehicleToggleButtonCarousel.styles';
import { useContext, useEffect } from 'react';
import { CarouselNavigation } from '@tribal-worldwide-london/ui-component-library-vwg';

interface VehicleToggleButtonCarouselProps {
  vehicleToggleButtons: VehicleToggleButtonProps[];
  background: BackgroundVals;
  activeSlide?: number;
}

export enum AriaLabels {
  CAROUSEL_ARIA_LABEL = 'Vehicle toggle button carousel',
  NAVIGATION_ARIA_LABEL = 'Navigation for vehicle toggle button carousel',
}

function VehicleToggleButtonCarousel({
  vehicleToggleButtons,
  background,
  activeSlide,
}: VehicleToggleButtonCarouselProps) {
  const isMobileWidth = useResizeResponsive(isMobile);

  const VehicleToggleButtonCarouselNavigation = () => {
    const galleryContext = useContext(GalleryContext);

    useEffect(() => {
      if (activeSlide) galleryContext.triggerChange(activeSlide);
    }, [activeSlide]);

    return <CarouselNavigation aria-label={AriaLabels.NAVIGATION_ARIA_LABEL} />;
  };

  return (
    <VehicleToggleButtonCarouselWrapper>
      <Gallery
        id="vehicle-toggle-button"
        fadingEdges
        bottomElements={
          isMobileWidth &&
          vehicleToggleButtons.length > 1 && (
            <VehicleToggleButtonCarouselNavigation />
          )
        }
        aria-label={AriaLabels.CAROUSEL_ARIA_LABEL}
        slidesPerPage={{
          [Breakpoints.default]: 1,
          [Breakpoints.b560]: 2,
          [Breakpoints.b960]: vehicleToggleButtons.length,
        }}
        gutter={
          isMobileWidth
            ? DesignTokenSizeEnum.static250
            : DesignTokenSizeEnum.static150
        }
      >
        {vehicleToggleButtons.map((vehicle) => (
          <GallerySlide
            key={vehicle.id}
            aria-labelledby={AriaLabels.CAROUSEL_ARIA_LABEL}
          >
            <VehicleToggleButton {...vehicle} background={background} />
          </GallerySlide>
        ))}
      </Gallery>
    </VehicleToggleButtonCarouselWrapper>
  );
}

export default VehicleToggleButtonCarousel;
